<template>
  <div class="bg_personnel">
    <v-container>
      <v-row justify="center">
        <h1 class="primary--text mb-5 mt-1">บุคลากรสาขาวิชาวิสัญญีวิทยา</h1>
      </v-row>
      <v-row>
        <v-col align="center" cols="4" v-for="item in items" :key="item.name">
          <v-avatar size="160" color="white" @click="$router.push(item.path)">
            <v-btn icon>
              <v-avatar tile size="160" color="white">
                <v-img max-height="80" max-width="80" :src="item.src"></v-img>
              </v-avatar>
            </v-btn>
          </v-avatar>

          <h3 class="black--text mt-2">{{ item.name }}</h3>
        </v-col>
      </v-row>
    </v-container>
    <DialogPersonnel ref="dialog_personnel_setting"></DialogPersonnel>
  </div>
</template>
<script>
import DialogPersonnel from "../Settings/DialogPersonnel";
export default {
  components: {
    DialogPersonnel,
  },
  data: () => ({
    mode: false,
    items: [
      {
        name: "อาจารย์วิสัญญีแพทย์",
        src: require("../../assets/icon/doctor1.svg"),
        path: "/anesthesiologist",
      },
      {
        name: "วิสัญญีพยาบาล/พยาบาล",
        src: require("../../assets/icon/nurse1.svg"),
        path: "nurseanesthetist",
      },
      {
        name: "พนักงานช่วยการพยาบาล",
        src: require("../../assets/icon/chemist1.svg"),
        path: "scienceofficer",
      },
      {
        name: " เจ้าหน้าที่สำนักงาน",
        src: require("../../assets/icon/author1.svg"),
        path: "anesthesiologystaff",
      },
      {
        name: "แพทย์ใช้ทุน",
        src: require("../../assets/icon/team1.svg"),
        path: "doctors",
      },
      {
        name: "พยาบาลเพิ่มพูนทักษะวิสัญญี",
        src: require("../../assets/icon/teacher1.svg"),
        path: "nurse",
      },
    ],
  }),
  created() {
    this.mode = this.$session.get("token") ? true : false;
  },
  methods: {
    logout() {
      this.$session.clear();
    },
    openSetting() {
      this.$refs.dialog_personnel_setting.openSetting();
    },
  },
};
</script>
